import { AuthGuard } from '@/auth/guard/auth.guard';
import { getDefinitionByPath } from '@/auth/routes/auth.routes';
import { ReportsComponent } from './reports.component';

export const ReportsChildRoutes = [
  {
    path: 'licenses',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/reports/licenses'),
  },
  {
    path: 'infractions',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/reports/infractions'),
  },
  {
    path: 'requests',
    component: ReportsComponent,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/reports/requests'),
  },
  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: '/reports/requests',
  },
];
